var map = {
	"./BLOCKED.svg": 7692,
	"./BLOCK_FRAUD.svg": 2359,
	"./CODE_GEN.svg": 285,
	"./FULL_REG.svg": 6060,
	"./PHONE_REG.svg": 6399,
	"./PRE_REG.svg": 3781,
	"./REG_NO_END.svg": 6873,
	"./calendar.svg": 3734,
	"./cart.svg": 9826,
	"./check-mark.svg": 5203,
	"./chevron.svg": 1955,
	"./dots.svg": 4186,
	"./folder.svg": 6630,
	"./lock.svg": 4592,
	"./logo-gns.svg": 5907,
	"./map-pin.svg": 4411,
	"./markets.svg": 6229,
	"./new_letter.svg": 4691,
	"./reports.svg": 7546,
	"./search.svg": 1868,
	"./unlock.svg": 6987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;